import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LangProvider } from "@/i18n/lang";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Inventory from "@/components/Inventory";
import Appointment from "@/components/Appointment";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

const Home = () => (
  <div className="min-h-screen bg-white font-body" data-testid="home-page">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Inventory />
      <Appointment />
      <About />
      <Contact />
    </main>
    <Footer />
    <Chatbot />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          className: "rounded-none border border-[#E4E4E7]",
          style: { fontFamily: "Manrope, sans-serif" },
        }}
      />
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
